import * as Icons from "lucide-react";
import { Reveal, StaggerGroup, StaggerItem } from "@/components/Reveal";
import { FEATURES } from "@/lib/siteData";

export const Features = () => {
  return (
    <section id="features" className="relative bg-background py-20 lg:py-28">
      <div className="mx-auto max-w-7xl px-5 lg:px-8">
        <Reveal className="mx-auto max-w-3xl text-center">
          <span className="mb-4 inline-block rounded-full bg-accent px-3.5 py-1.5 text-xs font-semibold uppercase tracking-wider text-accent-foreground">
            Website Management Platform
          </span>
          <h2 className="font-display text-3xl font-bold leading-tight tracking-tight text-navy sm:text-4xl lg:text-5xl">
            Manage your whole website from one simple place.
          </h2>
          <p className="mt-5 text-base text-muted-foreground md:text-lg">
            No code. No waiting. Just point, click, and update — whenever your business changes.
          </p>
        </Reveal>

        <StaggerGroup className="mt-14 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {FEATURES.map((f) => {
            const Icon = Icons[f.icon] || Icons.Sparkles;
            return (
              <StaggerItem key={f.title}>
                <div className="group flex h-full items-start gap-4 rounded-2xl border border-border bg-card p-5 shadow-sm transition-all duration-300 hover:-translate-y-1 hover:border-techblue/40 hover:shadow-card">
                  <div className="grid h-11 w-11 shrink-0 place-items-center rounded-xl bg-accent text-primary transition-colors duration-300 group-hover:bg-gradient-blue group-hover:text-primary-foreground">
                    <Icon className="h-5 w-5" />
                  </div>
                  <div>
                    <h3 className="font-display text-[15px] font-semibold text-navy">{f.title}</h3>
                    <p className="mt-1 text-sm leading-relaxed text-muted-foreground">{f.desc}</p>
                  </div>
                </div>
              </StaggerItem>
            );
          })}
        </StaggerGroup>
      </div>
    </section>
  );
};
